import { Button, IconButton } from "@mui/material";
import * as React from "react";
import BottomToolbarSetting from "./BottomToolbarSetting";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DialogDelete from "../../UI/DialogDelete";

const BottomToolbarView = (props) => {
  const {
    content,
    type,
    item,
    onChangeTable,
    onImageDimensionChange,
    index,
    onDeleteContent,
    onMoveUpContent,
    onMoveDownConent,
    ...others
  } = props;
  const [stateDialogDelete, setSateDialogDelete] = React.useState(false);

  const handleDelete = () => {
    setSateDialogDelete(true);
  };

  const handleDeleteConfirm = () => {
    setSateDialogDelete(false);
    onDeleteContent();
  };
  const handleCloseDialogDelete = () => {
    setSateDialogDelete(false);
  };

  return (
    <div
      style={{
        marginTop: "5px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <BottomToolbarSetting
        type={type}
        onChangeTable={onChangeTable}
        onImageDimensionChange={onImageDimensionChange}
        item={item}
      />
      <IconButton onClick={onMoveUpContent} disabled={index === 0}>
        <ArrowUpwardIcon
          disabled={index === 0}
          color={index === 0 ? "disabled" : "primary"}
        />
      </IconButton>
      <IconButton
        onClick={onMoveDownConent}
        disabled={index === content.length - 1}
      >
        <ArrowDownwardIcon
          color={index === content.length - 1 ? "disabled" : "primary"}
        />
      </IconButton>
      <IconButton onClick={handleDelete} style={{ marginLeft: "5px" }}>
        <DeleteIcon color="error" />
      </IconButton>
      <DialogDelete
        open={stateDialogDelete}
        disagreedelete={handleCloseDialogDelete}
        agreedelete={handleDeleteConfirm}
        description="Jeni të sigurt që doni ta fshini këtë seksion ?"
      />
    </div>
  );
};

export default BottomToolbarView;
